import styled, { css, DefaultTheme } from 'styled-components';

const OptionContainer = styled.div`
${({ theme }) => css`
  display: flex;
  gap: ${theme.spacing(2)};
  position: relative;
  `}
`;

interface OptionProps {
  isSelected: boolean,
  isCorrect: boolean,
  isMarked: boolean,
  disabled: boolean,
}

const getColor = (
  theme: DefaultTheme,
  isSelected: boolean,
  isCorrect: boolean,
  isMarked: boolean) => {
  if (isSelected) {
    return theme.palette.gray.light;
  }
  return (isMarked && isCorrect) ? theme.palette.error.light : theme.palette.backdrop.main;
};

const Option = styled.div<OptionProps>`
  ${({ theme, isSelected, isCorrect, isMarked, disabled }) => css`
    color: ${isSelected ? theme.palette.gray.contrastText : theme.palette.backdrop.contrastText};
    font-weight: ${isSelected ? 'bold' : 'normal'};
    /* border: 1px solid ${theme.palette.backdrop.contrastText}; */
    background-color: ${getColor(theme, isSelected, isCorrect, isMarked)};
    border-radius: 50%;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: ${disabled ? 'default' : 'pointer'};
  `}
`;

interface CorrectIndicatorProps {
  isCorrect: boolean,
}

const CorrectIndicator = styled.div<CorrectIndicatorProps>`
  color: ${({ theme, isCorrect }) => (isCorrect ? theme.palette.success.main : theme.palette.error.main)};
  font-size: 24px;
  position: absolute;
  right: -${({ theme }) => theme.spacing(3)};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
`;

export { OptionContainer, Option, CorrectIndicator };
